import React, { useState } from "react";
import aws from "../images/icons/aws.png";
import figmaIcon from "../images/icons/figma.png";
import gitlabIcon from "../images/icons/gitlab.png";
import githubIcon from "../images/icons/git.png";
import googleIcon from "../images/icons/google.png";
import cypressIcon from "../images/icons/cypress.png";
import jiraIcon from "../images/icons/jira.png";
import netlifyIcon from "../images/icons/netlify.png";
import renderIcon from "../images/icons/render.png";
import slackIcon from "../images/icons/slack.png";
import trelloIcon from "../images/icons/trello.png";
import vscodeIcon from "../images/icons/vscode.png";
import gptIcon from "../images/icons/gpt.png";
import javasIcon from "../images/icons/JS.png";
import reactIcon from "../images/icons/react.png";
import sassIcon from "../images/icons/sass.png";
import bootstrapIcon from "../images/icons/Bootstrap.png";
import tailwindIcon from "../images/icons/tailwind.png";

export const Skills = ({ skillsRef }) => {
    const skills = [
        {
            name: "Planning",
            description:
                "I practised Figma for seamless UI/UX design collaboration, Trello for streamlined project management with visual boards, Slack for real-time communication within your development team, and Google Docs for collaborative documentation of project requirements and technical details.",
            tools: {
                toolName: ["Figma", "Trello", "Slack", "Google Docs"],
                toolIcon: [figmaIcon, trelloIcon, slackIcon, googleIcon],
            },
        },
        {
            name: "Requirements",
            description:
                "My experience with Trello helped me with initial project planning and organization of requirements, while Jira provided me advanced issue tracking and project management capabilities during the requirements phase.",
            tools: {
                toolName: ["Trello", "Jira"],
                toolIcon: [trelloIcon, jiraIcon],
            },
        },

        {
            name: "Design",
            description:
                "I use Sass, Bootstrap and Tailwind for quick and comprehensive design implementation during the coding phase.",
            tools: {
                toolName: ["Sass", "Bootstrap", "Tailwind"],
                toolIcon: [sassIcon, bootstrapIcon, tailwindIcon],
            },
        },

        {
            name: "Coding",
            description:
                "VSCode real-time collaboration tools and built-in debugging functions helped me to create, edit, and debug my code. By its rich ecosystem of extensions coding becomes easier, enhancing productivity and code quality. ",
            tools: {
                toolName: ["VSCode", "Javascript", "React"],
                toolIcon: [vscodeIcon, javasIcon, reactIcon],
            },
        },

        {
            name: "Testing",
            description:
                "With Cypress testing phase and guaranteeing the reliability and functionality of my web development projects is fun. GPT provide thorough code review and testing assistance, offering valuable insights and corrections to enhance the quality and reliability of my web development projects",
            tools: {
                toolName: ["Cypress", "GPT"],
                toolIcon: [cypressIcon, gptIcon],
            },
        },

        {
            name: "Deployment",
            description:
                "Dealt with seamless deployment journey with trusted platforms like Netlify, Render, Cloudways, AWS, and GitHub, ensuring my web project reaches its audience effortlessly.",
            tools: {
                toolName: ["Netlify", "Render", "AWS", "Github"],
                toolIcon: [netlifyIcon, renderIcon, aws, githubIcon],
            },
        },

        {
            name: "Maintenance",
            description:
                "I maintained web project using version control systems like Github and Gitlab, ensuring smooth collaboration and continuous improvement.",
            tools: {
                toolName: ["Github", "Gitlab"],
                toolIcon: [githubIcon, gitlabIcon],
            },
        },
    ];

    const [selectedSkill, setSelectedSkill] = useState("Planning");

    const handleSkillClick = (skillName) => {
        setSelectedSkill(skillName);
        console.log(selectedSkill);
    };

    return (
        <div className="Skills" ref={skillsRef}>
            <div className="Skills-Cont1">Web Development</div>
            <div className="Skills-Cont2">
                {skills.map((skill, index) => (
                    <div
                        key={index}
                        className="Skills-Cont2-Item"
                        onClick={() => handleSkillClick(skill.name)}
                    ></div>
                ))}
            </div>
            <div className="Skills-Cont3">
                {skills.map((skill, index) => (
                    <div
                        key={index}
                        className="Skills-Cont3-Box"
                        style={{
                            opacity: selectedSkill === skill.name ? 1 : 0,
                        }}
                    >
                        <div className="Skills-Cont3-Name">{skill.name}</div>
                        <div className="Skills-Cont3-Description">
                            {skill.description}
                        </div>
                        <div className="Skills-Cont3-Tools-Box">
                            {skill.tools.toolName.map((tool, toolIndex) => (
                                <div key={toolIndex} className="Tool">
                                    <img
                                        src={skill.tools.toolIcon[toolIndex]}
                                        alt={`${tool} Icon`}
                                        className="Skills-Cont3-Tools-Icon"
                                    />
                                    <div className="Skills-Cont3-Tools-Name">
                                        {tool}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
